(function () {
  'use strict';

  var refreshTimer = null;

  function markWinesPage() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path !== '/pages/wines') return;

    document.documentElement.classList.add('wc-wines-page');

    var hero = document.querySelector('[data-wc-indexed-hero]');
    var catalogue = document.querySelector('[data-wc-catalogue]');
    var heroSection = hero ? hero.closest('.shopify-section') : null;
    var catalogueSection = catalogue ? catalogue.closest('.shopify-section') : null;

    if (!heroSection || !catalogueSection) return;

    var section = heroSection.nextElementSibling;
    while (section && section !== catalogueSection) {
      if (section.classList.contains('shopify-section')) {
        section.classList.add('wc-wines-prelude');
      }
      section = section.nextElementSibling;
    }
  }

  function markControlledSubmenus() {
    document
      .querySelectorAll('.wc-site-header__nav-item--has-submenu > [data-wc-submenu-trigger]')
      .forEach(function (trigger) {
        var item = trigger.closest('.wc-site-header__nav-item--has-submenu');
        if (item) item.classList.add('wc-controlled-submenu');
      });
  }

  function handleEscape(event) {
    if (event.key !== 'Escape') return;

    var openItem = document.querySelector(
      '.wc-site-header__nav-item.wc-controlled-submenu.is-open'
    );
    if (!openItem) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var trigger = openItem.querySelector('[data-wc-submenu-trigger]');
    openItem.classList.remove('is-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      try {
        trigger.focus({ preventScroll: true });
      } catch (error) {
        trigger.focus();
      }
    }
  }

  function applyFixes() {
    markWinesPage();
    markControlledSubmenus();
  }

  function scheduleFixes() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(applyFixes, 80);
  }

  document.addEventListener('keydown', handleEscape, true);
  document.addEventListener('shopify:section:load', scheduleFixes);

  function initialise() {
    applyFixes();

    var observer = new MutationObserver(scheduleFixes);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
